/**
 * @generated SignedSource<<ebd4c0c6257ae50ed7244cafd695c187>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SharedFollowSearchProvider_user$data = {
  readonly favorites: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly serviceId: string | null;
      } | null;
    } | null> | null;
    readonly " $fragmentSpreads": FragmentRefs<"SaveSearchButton_favoritesConnection">;
  } | null;
  readonly id: string;
  readonly " $fragmentType": "SharedFollowSearchProvider_user";
};
export type SharedFollowSearchProvider_user$key = {
  readonly " $data"?: SharedFollowSearchProvider_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"SharedFollowSearchProvider_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "followSearchPages"
    },
    {
      "kind": "RootArgument",
      "name": "followSearchTypes"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [
        "node"
      ],
      "operation": require('./SharedFollowSearchProviderRefetchQuery.graphql'),
      "identifierField": "id"
    }
  },
  "name": "SharedFollowSearchProvider_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 1
        },
        {
          "kind": "Variable",
          "name": "pages",
          "variableName": "followSearchPages"
        },
        {
          "kind": "Variable",
          "name": "types",
          "variableName": "followSearchTypes"
        }
      ],
      "concreteType": "favoritesConnection",
      "kind": "LinkedField",
      "name": "favorites",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SaveSearchButton_favoritesConnection"
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "favoritesEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Favorite",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "serviceId",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "53b8c6d79ded8da2ea4ab5aac95ed6b8";

export default node;
